
<div class="chat"
     [class.busy]="busy()"
     [class.creating-session]="creatingSession()"
     [class.sending-user-prompt]="sendingUserPrompt()"
     [class.awaiting-response]="awaitingResponse()"
     [class.completed]="completed()"
     [class.failed]="failed()">
  <div class="chat-top" #chatTop>
    <ng-content select="[beforeMessages]"></ng-content>
    <div class="chat-messages">
      @for (m of messages(); track m.id) {
        <app-ai-agent-chat-message [message]="m" (messageTyped)="onMessageTyped(m.index)">
        </app-ai-agent-chat-message>
      }

      <div class="chat-message-waiting-for-response pulse" [hidden]="!awaitingResponse()">
        <span>Agent is responding...</span>
      </div>
    </div>
    <ng-content select="[afterMessages]"></ng-content>
  </div>
  <div class="chat-bottom">
    <div class="chat-pending-message-snack"
         [hidden]="isScrolledDown() || !userScrolled()"
         (click)="scrollToBottom()">
      <span>Show latest message</span>
    </div>

    <div class="chat-user-input-wrapper" [style.minHeight]="minTextAreaHeight() + 'px'">
      <form (submit)="userPromptSend(textArea)" style="display: contents;">
        <textarea #textArea
                  class="chat-user-input"
                  [(value)]="userPromptText"
                  [disabled]="!canSendUserPrompt()"
                  (change)="onUserPromptTextInput(textArea)"
                  (input)="onUserPromptTextInput(textArea)"
                  (paste)="onUserPromptTextInput(textArea)"></textarea>
      </form>
    </div>
    <i class="chat-submit-icon fas fa-caret-square-up i-30 c-blue user-select-none" (click)="userPromptSend(textArea)"></i>
  </div>
</div>
